module.exports = __webpack_public_path__ + "img/why-icon-active-5.5f40070a.svg";